import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { memo, useMemo } from 'react';
import { formatSeconds } from '@dtvgo/date-utils';
import DotTooltip from './DotTooltip.js';
import ScrubbingSpeedIcon from './ScrubbingSpeedIcon.js';
import { ScrubbingDirection, ProgressBarClassNames, COLOR_BLUE } from './utils.js';
import { useSeekingValue, useScrubbing } from './ProgressBarContext.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import '@dtvgo/slider';
import '@dtvgo/tooltip';
import '@dtvgo/icon';
import '@dtvgo/classnames';

var _ArrowPlacement;
var ArrowPlacement = (_ArrowPlacement = {}, _defineProperty(_ArrowPlacement, ScrubbingDirection.BACKWARD, 'right'), _defineProperty(_ArrowPlacement, ScrubbingDirection.FORWARD, 'left'), _ArrowPlacement);
function SeekingDot(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    _ref$tooltipBgColor = _ref.tooltipBgColor,
    tooltipBgColor = _ref$tooltipBgColor === void 0 ? COLOR_BLUE : _ref$tooltipBgColor,
    _ref$formatTooltip = _ref.formatTooltip,
    formatTooltip = _ref$formatTooltip === void 0 ? formatSeconds : _ref$formatTooltip;
  var seekingValue = useSeekingValue();
  var _useScrubbing = useScrubbing(),
    direction = _useScrubbing.direction,
    speed = _useScrubbing.speed;
  var scrubbingIcon = useMemo(function () {
    return /*#__PURE__*/jsx(ScrubbingSpeedIcon, {
      direction: direction,
      speed: speed
    });
  }, [direction, speed]);
  var children = useMemo(function () {
    return seekingValue !== null && /*#__PURE__*/jsxs("span", {
      children: [direction === ScrubbingDirection.BACKWARD ? /*#__PURE__*/jsxs(Fragment, {
        children: [scrubbingIcon, ' ']
      }) : null, formatTooltip(seekingValue), direction === ScrubbingDirection.FORWARD ? /*#__PURE__*/jsxs(Fragment, {
        children: [' ', scrubbingIcon]
      }) : null]
    });
  }, [direction, formatTooltip, scrubbingIcon, seekingValue]);
  return seekingValue !== null && /*#__PURE__*/jsx(DotTooltip, {
    className: ProgressBarClassNames.element('seeking-dot', className),
    placement: placement,
    arrowPlacement: ArrowPlacement[direction],
    tooltipBgColor: tooltipBgColor,
    value: seekingValue,
    children: children
  });
}
var SeekingDot$1 = /*#__PURE__*/memo(SeekingDot);

export { SeekingDot$1 as default };
//# sourceMappingURL=SeekingDot.js.map
